import { render } from "./CreateUser.vue?vue&type=template&id=aaa0c572"
import script from "./CreateUser.vue?vue&type=script&lang=ts"
export * from "./CreateUser.vue?vue&type=script&lang=ts"
script.render = render

export default script